// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 296 ? "ea88be26" : chunkId) + "." + {"260":"cd993ebc1e92a42c","296":"d77cd32e064e0da5"}[chunkId] + ".js";
};